
<template>
    <control-wrapper v-bind="controlWrapper" :styles="styles" :appliedOptions="appliedOptions">
        <div v-if="!readonly">
            <v-file-input style="padding-top: 20px;" v-model="fileList" small-chips :label="computedLabel"
                @change="beforeRead" show-size :accept="appliedOptions.accept" :multiple="appliedOptions.multiple"
                :placeholder="appliedOptions.placeholder" :error-messages="control.errors" counter  />
            <v-progress-linear :active="isuploading" :indeterminate="isuploading" absolute bottom
                color="deep-purple accent-4"></v-progress-linear>

            <v-text-field style="display:none" :id="control.id + '-input'" v-model="control.data"
                v-bind="vuetifyProps('v-text-field')" @input="onChange" />
        </div>
        <div v-else>
            <v-label :class="styles.label.root" v-bind="vuetifyProps('v-label')">{{ computedLabel }}</v-label>
            <el-link style="padding-left:10px;" v-for="item in uploadInfo" :key="item.fid" type="primary"
                @click="btnClick(item)">{{ item.fileName }}</el-link>
        </div>
    </control-wrapper>
</template>

<script >
import { formatIs, rankWith } from '@jsonforms/core';

import { rendererProps, useJsonFormsControl, } from '@jsonforms/vue2';
import { useVuetifyControl, ControlWrapper } from '@jsonforms/vue2-vuetify';
import { defineComponent, ref } from 'vue';
import userDocApi from "@/assets/js/userDocApi";
const controlRenderer = defineComponent({
    name: 'uploader',
    inject: ['jsonforms'],
    props: {
        ...rendererProps(),
    },
    components: {
        ControlWrapper
    },
    setup(props, context) {
        const fileList = ref([])
        const uploadInfo = ref([])
        const finishUpload = ref(false)
        const isuploading = ref(false)
        const adaptValue = (value) => value || undefined;
        // const readonly =ref(props.enabled);

        const control = useVuetifyControl(useJsonFormsControl(props), (value) => value || undefined);
        return { fileList, uploadInfo, finishUpload, isuploading, ...control }

    },

    computed: {
        readonly() {
            return this.jsonforms.readonly

        }


    },
    created() {
        if (this.readonly) {
            if (this.control.data != "")
                this.uploadInfo = this.control.data
        }
        // console.log(this);
    },
    methods: {
        afterRead(file) {
            this.isuploading = true
            let _param = {}
            _param.content = file;
            _param.name = $func.getUUID_resource() + "_" + file.name;
            _param.label = file.name
          
            userDocApi.createFile('usys/products/release/cache', _param.name, _param, _r => {
                this.isuploading = false;
                if (_r.code == 200) {

                    // this.uploadfid=_r.data.fid;
                    let _rsl = {
                        path: `usys/products/release/cache/${file.name}`,
                        fileName: file.name,
                        fileSize: file.size,
                        fid: _r.data.fid
                    };
                    this.uploadInfo.push(_rsl)
                    this.finishUpload = true;
                    // this.fileList=[];
                    this.control.data = `ndisk:${JSON.stringify(this.uploadInfo)}`;
                    this.onChange(this.control.data)

                } else {
                    this.$notify({ type: 'danger', message: '上传文件失败' })
                }

                // console.log(_r);
            })


        },
        formatFileSize(size) {
            var fileSize = ""
            if (size > 1024 * 1024) {
                fileSize = (size / (1024 * 1024)).toFixed(2) + "MB"
            } else {
                fileSize = (size / 1024).toFixed(2) + "KB"
            }
            return fileSize;
        },
        
        

        beforeRead(file) {

            if(file==null){
                
                return;
            }

            // 验证
            let res = true;
            // console.log(this.fileList)
            if (res) {
                this.afterRead(this.fileList);
            }
            // return true;
        },
        btnClick(item) {
            userDocApi.downloadByPath(item.path, item.fileName, _r => {
                console.log(_r);
            })
        }
    },
})

export default controlRenderer;
export const entry = {
    renderer: controlRenderer,
    tester: rankWith(10, formatIs("zysl-uploader")),
};
</script>

<style lang="less" scoped>
.divuploader {
    text-align: center;
}

.fileInfo {
    font-size: 14px;
    padding: 10px;

}

.fileInfo .van-cell__value {
    text-align: left
}


.fileInfo .van-field .van-field__label {
    width: auto;
}

.fileInfo .fileSize {
    line-height: 16px;
    // height: 20px;
}

.btnpbcDebug {
    text-align: center;
}

.debugfinish {
    text-align: center;
}

/deep/.deep-purple.accent-4 {
    background-color: #6200ea!important;
    border-color: #6200ea!important;
}

/deep/.van-dialog__header {
    padding-top: 5px;
}
</style>
